import type { ReactNode } from 'react';
import { BryqProvider } from './BryqContext';
import { CandidatePanelProvider } from './CandidatePanelContext';
import { EmailHistoryProvider } from './EmailHistoryContext';
import { NotesProvider } from './NotesContext';

/**
 * The providers behind the per-candidate chips on every card: 📝 notes, ✉️ email history,
 * 🧠 Bryq and 📋 the candidate panel. One wrapper so the board view (at its line limit) mounts
 * them in one place. `key` on the email history keeps its per-board cache from leaking across
 * boards, and the panel carries one too for the same reason.
 *
 * `verdicts` is the board payload's own verdict map — the only thing any of these chips reads
 * from the board rather than fetching on click.
 */
export function CandidateChipsProvider({
  boardEmail,
  verdicts,
  children,
}: {
  boardEmail: string;
  verdicts?: Record<string, string[]>;
  children: ReactNode;
}) {
  return (
    <NotesProvider boardEmail={boardEmail}>
      <EmailHistoryProvider key={boardEmail} boardEmail={boardEmail}>
        <BryqProvider boardEmail={boardEmail}>
          <CandidatePanelProvider key={boardEmail} boardEmail={boardEmail} verdicts={verdicts}>
            {children}
          </CandidatePanelProvider>
        </BryqProvider>
      </EmailHistoryProvider>
    </NotesProvider>
  );
}
